export const environment = {
  production: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts